/* Os prazos de "Silenciar avisos" e "Lembrar depois" no Chat (docs/propostas/chat/menu-e-atalhos.html §17).
   Quem decide o instante de verdade é a API (PrazosDaCaixa.cs); este arquivo repete a conta só para a tela
   mostrar o horário no rótulo do menu e já agir na hora (atualização otimista). Quando a API responde, o
   instante dela substitui o daqui. Brasília sem horário de verão: UTC−3 fixo, o mesmo da API. */

export type PrazoSilencio = '8h' | '1d' | 'sempre';
export type PrazoLembrete = '1h' | 'amanha' | 'segunda';

const HORA = 3_600_000;
const DIA = 24 * HORA;
const DESLOCAMENTO_BRASILIA = -3 * HORA;
const HORA_DA_VOLTA = 8;

/** "Até religar": uma data bem distante, a mesma da API (2100-01-01 UTC). */
export const SILENCIO_SEMPRE = Date.UTC(2100, 0, 1);

/** Relógio de parede de Brasília de um instante: usa os getters UTC de uma data deslocada. */
const emBrasilia = (instante: number) => new Date(instante + DESLOCAMENTO_BRASILIA);
const meiaNoiteBrasiliaEmUtc = (instante: number) => {
    const b = emBrasilia(instante);
    return Date.UTC(b.getUTCFullYear(), b.getUTCMonth(), b.getUTCDate()) - DESLOCAMENTO_BRASILIA;
};

export const instanteDoSilencio = (prazo: PrazoSilencio, agora = Date.now()): number => {
    if (prazo === '8h') return agora + 8 * HORA;
    if (prazo === '1d') return agora + DIA;
    return SILENCIO_SEMPRE;
};

export const instanteDoLembrete = (prazo: PrazoLembrete, agora = Date.now()): number => {
    if (prazo === '1h') return agora + HORA;
    const hoje = meiaNoiteBrasiliaEmUtc(agora);
    if (prazo === 'amanha') return hoje + DIA + HORA_DA_VOLTA * HORA;
    // Na segunda-feira, "próxima segunda" é daqui a sete dias.
    const diaDaSemana = emBrasilia(agora).getUTCDay();
    const dias = (1 - diaDaSemana + 7) % 7;
    return hoje + (dias === 0 ? 7 : dias) * DIA + HORA_DA_VOLTA * HORA;
};

/** "8h" quando é hora cheia, "15h02" quando não é. */
export const horaCurta = (instante: number): string => {
    const b = emBrasilia(instante);
    const h = b.getUTCHours();
    const m = b.getUTCMinutes();
    return m === 0 ? `${h}h` : `${h}h${String(m).padStart(2, '0')}`;
};

/** O horário do rótulo do submenu: "15:02" para "Em 1 hora", "8h" para os de 8h. */
export const horarioDoPrazo = (prazo: PrazoLembrete, agora = Date.now()): string => {
    const instante = instanteDoLembrete(prazo, agora);
    if (prazo !== '1h') return horaCurta(instante);
    const b = emBrasilia(instante);
    return `${String(b.getUTCHours()).padStart(2, '0')}:${String(b.getUTCMinutes()).padStart(2, '0')}`;
};

const SEMANA = ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'];

/** A prévia da linha dentro da pasta Lembretes: "Volta amanhã às 8h". */
export const textoDaVolta = (instante: number, agora = Date.now()): string => {
    const dias = Math.round((meiaNoiteBrasiliaEmUtc(instante) - meiaNoiteBrasiliaEmUtc(agora)) / DIA);
    const hora = horaCurta(instante);
    if (dias <= 0) return `Volta hoje às ${hora}`;
    if (dias === 1) return `Volta amanhã às ${hora}`;
    if (dias < 7) return `Volta ${SEMANA[emBrasilia(instante).getUTCDay()]} às ${hora}`;
    const b = emBrasilia(instante);
    const dd = String(b.getUTCDate()).padStart(2, '0');
    const mm = String(b.getUTCMonth() + 1).padStart(2, '0');
    return `Volta em ${dd}/${mm} às ${hora}`;
};
